// src/utils/promemoriaOrari.js
// ═══════════════════════════════════════════════════════════════════════════
// «🔔 RICORDAMELO ALLE» — promemoria a orario scelto (ottobre 2026)
// Ognuno si imposta i propri promemoria su attività e sottoattività (collezione
// "promemoria", privata: la legge e la scrive solo chi l'ha creata — firestore rules 55).
// Il server controlla UNA volta all'ora, allo scoccare dell'ora (functions:
// promemoriaOrari): per questo si scelgono solo ore piene, dalla prossima in poi.
// All'ora indicata arrivano avviso nella campanella, notifica sul dispositivo ed email;
// poi il promemoria si cancella da solo.
// Chiave dell'orario: "AAAA-MM-GGTHH:00" in ora italiana (si confronta come testo).
// ═══════════════════════════════════════════════════════════════════════════
import { toLocalDateStr } from "./dateUtils";

const p2 = n => String(n).padStart(2, "0");

export const chiaveOrario = (data, ora) => `${data}T${p2(ora)}:00`;

/** Prima ora piena utile: quella dopo l'ora attuale (alle 14:20 → 15:00). */
export function primaOraUtile(adesso = new Date()) {
  const d = new Date(adesso);
  d.setMinutes(0, 0, 0);
  d.setHours(d.getHours() + 1);
  return { data: toLocalDateStr(d), ora: d.getHours() };
}

/** Ore selezionabili per un giorno: tutte, oppure dalla prima ora utile se è oggi (o nulla se passato). */
export function oreDisponibili(data, adesso = new Date()) {
  const { data: dPrima, ora: oPrima } = primaOraUtile(adesso);
  if (!data) return [];
  if (data < dPrima) return [];
  const da = data === dPrima ? oPrima : 0;
  return Array.from({ length: 24 - da }, (_, i) => da + i);
}

/** L'orario scelto è ancora valido (dalla prossima ora piena in poi)? */
export function orarioValido(chiave, adesso = new Date()) {
  const { data, ora } = primaOraUtile(adesso);
  return !!chiave && chiave >= chiaveOrario(data, ora);
}

/**
 * Scelte rapide rispetto alla scadenza con orario: «1 ora prima», «2 ore prima»,
 * arrotondate all'ora piena precedente (scadenza 16:30 → 1 ora prima = 15:00).
 * Solo quelle ancora possibili.
 */
export function sceltePrimaDellaScadenza(dueDate, dueTime, adesso = new Date()) {
  if (!dueDate || !/^\d{2}:\d{2}$/.test(dueTime || "")) return [];
  const [h, m] = dueTime.split(":").map(Number);
  return [1, 2, 3].map(ore => {
    const d = new Date(`${dueDate}T${p2(h)}:${p2(m)}:00`);
    d.setHours(d.getHours() - ore);
    d.setMinutes(0, 0, 0);
    return { etichetta: `${ore} or${ore === 1 ? "a" : "e"} prima`, chiave: chiaveOrario(toLocalDateStr(d), d.getHours()) };
  }).filter(s => orarioValido(s.chiave, adesso));
}

/** "15/10 alle 15:00" */
export function testoOrario(chiave) {
  if (!chiave) return "";
  const [data, ora] = chiave.split("T");
  const [a, mm, g] = data.split("-");
  const oggi = toLocalDateStr(new Date());
  const domani = toLocalDateStr(new Date(Date.now() + 86400000));
  const giorno = data === oggi ? "oggi" : data === domani ? "domani" : `il ${g}/${mm}${a !== oggi.slice(0, 4) ? "/" + a : ""}`;
  return `${giorno} alle ${ora.slice(0, 5)}`;
}
